export default __webpack_public_path__ + "static/media/Kanit-Medium.dd669b98.ttf";